<template>
  <div class="provider-branded-home">
    <div id="stickyBlockStartPoint" />
    <div class="section-container">
      <!-- ========== Hero Section ========== -->
      <div id="modern-hero-section" class="section bg-img theme-bg cover-bg bg-img-hero">
        <!-- <div class="branded-cover-image-container">
          <template v-if="!loaded">
            <SkeletonUI type="img" class="cover-image" />
          </template>
          <template v-else>
            <img
              id="modern-hero-section"
              v-img="{ type:'xl', class: 'cover-image' }"
              class="w-100 branded-cover-image"
            >
          </template>
        </div> -->
        <template>
          <div class="hero-section-conatiner">
            <div class="hero-section">
              <h2 class="text-white title">{{ providerInfo[0] && providerInfo[0].theme_data && providerInfo[0].theme_data.landing && providerInfo[0].theme_data.landing.hero_section && providerInfo[0].theme_data.landing.hero_section.title ? providerInfo[0].theme_data.landing.hero_section.title : 'Grow Your Business with Our Open API Solutions' }}</h2>
              <p class="text-white description">{{ providerInfo[0] && providerInfo[0].theme_data && providerInfo[0].theme_data.landing && providerInfo[0].theme_data.landing.hero_section && providerInfo[0].theme_data.landing.hero_section.description ? providerInfo[0].theme_data.landing.hero_section.description : 'Discover our flexible API plans for different stages of your business' }}</p>
              <div v-if="providerInfo[0] && providerInfo[0].theme_data && providerInfo[0].theme_data.landing && providerInfo[0].theme_data.landing.hero_section && providerInfo[0].theme_data.landing.hero_section.buttons && providerInfo[0].theme_data.landing.hero_section.buttons.length > 0" class="button-container flex-column flex-md-row w-sm-80 w-md-100 mx-auto">
                <a
                  v-for="(button, index) in providerInfo[0].theme_data.landing.hero_section.buttons"
                  :key="button.text"
                  :class="index % 2 === 0 ? 'btn theme-button-modern' : 'theme-button-outline-modern btn transparent-button text-white ml-0 ml-md-2 mt-2 mt-md-0'"
                  :href="button.url"
                  target="_blank"
                >{{ button.text }}</a>
              </div>
            </div>
          </div>
        </template>
      </div>
      <!-- ========== End Hero Section ========== -->

      <!-- ========== Quick Link Section ========== -->

      <div class="section quick_link-pb quick_link-mt">
        <div class="container">
          <div class="row justify-content-center">
            <div v-for="(card, index) in home_cards" :key="index" class="col-md-4 mb-3 mb-md-0">
              <!-- Intro Card -->
              <div class="card h-100 transition-3d-hover">
                <div class="card-body pt-lg-5 px-lg-5 pb-lg-0">
                  <div class="media align-items-center">
                    <div class="media-body">
                      <div class="icon-container">
                        <i class="theme-text fs-48" :class="card.icon" />
                      </div>
                      <h3 class="card-title my-3">{{ $t(card.title) }} </h3>
                    </div>
                  </div>
                  <p class="mb-0">{{ $t(card.description, { provider: card.provider_display_name ? providerInfo[0].display_name : undefined }) }}</p>
                </div>
                <div class="card-footer font-weight-bold pb-5 px-lg-5 border-top-0">
                  <router-link
                    class="theme-link"
                    :to="{ name: 'provider-info-branded', params: { provider_name: $route.params.provider_name, tab_name: card.link, lang: $route.params.lang }, hash: card.hash }"
                  >
                    {{ $t(card.link_text) }}<i class="fas fa-angle-right fa-sm ml-1" />
                  </router-link>

                </div>
              </div>
              <!-- End Intro Card -->
            </div>
          </div>
        </div>
      </div>

      <!-- ========== End Quick Link Section ========== -->

      <!-- ========== Trending APIs ========== -->
      <div v-if="latestApis.length > 0" class="section space-2">
        <div class="container">
          <!-- Title -->
          <!-- <div class="row align-items-md-center mb-2"> -->
          <div class="mb-2 mb-md-0 text-center">
            <h2>{{ $t('M05A-1-09') }}</h2>
          </div>
          <!-- </div> -->
          <ApiCarousel
            :key="`latest-apis-${Date.now()}`"
            class="api-carousel-featured my-5"
            :items="latestApis"
            :apiCardClickHandler="goToApiInfo"
            :isBranded="true"
            :fromProvider="true"
            carouselId="api-carousel-latest"
            :loading="loading"
          />
          <!-- <div class="row align-items-md-center mb-2"> -->
          <div class="text-center">
            <router-link :to="{ name: 'provider-info-branded', params: { provider_name: $route.params.provider_name, tab_name: 'api' } }">
              <b class="theme-button btn btn-primary text-white mt-5">{{ $t('M05A-1-10a') }} <i class="fa fa-angle-right fa-sm ml-1" /></b>
            </router-link>
          </div>
          <!-- </div> -->
        </div>
      </div>
      <!-- ========== End Trending APIs ========== -->

      <!-- ========== Feature Section ========== -->
      <div v-if="providerInfo[0] && providerInfo[0].theme_data && providerInfo[0].theme_data.landing && providerInfo[0].theme_data.landing.feature_section && providerInfo[0].theme_data.landing.feature_section.title" class="section space-2">
        <div>
          <div class="container project-highlights-section">
            <h3 class="title">{{ providerInfo[0].theme_data.landing.feature_section.title }}</h3>
            <div v-if="providerInfo[0].theme_data.landing.feature_section.statistics && providerInfo[0].theme_data.landing.feature_section.statistics.length > 0" class="d-flex flex-column flex-lg-row mb-5">
              <div v-for="(statistic, index) in providerInfo[0].theme_data.landing.feature_section.statistics" :key="index" class="statistic" :class="{ 'mb-5 mb-lg-0 hr': index < providerInfo[0].theme_data.landing.feature_section.statistics.length - 1 }">
                <p class="number theme-text">{{ statistic.prefix }}{{ statistic.number }}{{ statistic.suffix }}</p>
                <h3 class="subtitle">{{ statistic.subtitle }}</h3>
              </div>
            </div>
          </div>
        </div>

        <div v-if="providerInfo[0] && providerInfo[0].theme_data && providerInfo[0].theme_data.landing && providerInfo[0].theme_data.landing.feature_section && providerInfo[0].theme_data.landing.feature_section.features && providerInfo[0].theme_data.landing.feature_section.features.length > 0">
          <div class="feature-card-container container d-flex flex-wrap justify-content-center">
            <div v-for="feature in providerInfo[0].theme_data.landing.feature_section.features" :key="feature.title" class="feature-card col-12 col-md-3">
              <div class="card-body flex-md-column d-flex">
                <div class="icon-container theme-icon-bg">
                  <i class="theme-text icon" :class="feature.icon" />
                </div>
                <div>
                  <h2 class="title">{{ feature.title }}</h2>
                  <div class="description">{{ feature.description }}</div>
                  <div v-if="feature.button && feature.button.text" class="button-container theme-button-container">
                    <a class="theme-link font-weight-bold" :href="feature.button.url" target="_blank">{{ feature.button.text }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ========== End Feature Section ========== -->

      <!-- ========== How it Works Section ========== -->
      <div v-if="providerInfo[0] && providerInfo[0].theme_data && providerInfo[0].theme_data.landing && providerInfo[0].theme_data.landing.hiw_section && providerInfo[0].theme_data.landing.hiw_section.items && providerInfo[0].theme_data.landing.hiw_section.items.length > 0" class="section space-2">
        <div class="container">
          <h2 v-if="providerInfo[0].theme_data && providerInfo[0].theme_data.landing && providerInfo[0].theme_data.landing.hiw_section && providerInfo[0].theme_data.landing.hiw_section.title" class="section-title mb-5 text-center">{{ providerInfo[0].theme_data.landing.hiw_section.title }}</h2>
          <HowItWorkCarousel
            :items="providerInfo[0].theme_data.landing.hiw_section.items"
          />
        </div>
      </div>
      <!-- ========== End How it Works Section ========== -->

      <!-- ========== Call to Action Section ========== -->
      <div v-if="providerInfo[0] && providerInfo[0].theme_data && providerInfo[0].theme_data.landing && providerInfo[0].theme_data.landing.call_to_action_section && providerInfo[0].theme_data.landing.call_to_action_section.title" id="modern-cta-section" class="section cover-bg space-2 bg-img-hero">
        <div class="container">
          <div class="call-to-action-section text-center ">
            <h2 class="title">{{ providerInfo[0].theme_data.landing.call_to_action_section.title }}</h2>
            <p class="description mb-0">{{ providerInfo[0].theme_data.landing.call_to_action_section.description }}</p>
            <div v-if="providerInfo[0].theme_data.landing.call_to_action_section.buttons && providerInfo[0].theme_data.landing.call_to_action_section.buttons.length > 0" class="button-container flex-column flex-lg-row mt-5 w-sm-80 w-lg-100 mx-auto">
              <a
                v-for="(button, index) in providerInfo[0].theme_data.landing.call_to_action_section.buttons"
                :key="button.text"
                :class="index % 2 === 0 ? 'theme-button btn btn-primary text-white' : 'theme-button-outline btn btn-outline-primary btn-white ml-0 ml-lg-2 mt-2 mt-lg-0'"
                :href="button.url"
                target="_blank"
              >{{ button.text }}</a>
            </div>
          </div>
        </div>
      </div>
    <!-- ========== End Call to Action Section ========== -->
    </div>
    <div id="stickyBlockEndPoint" />
    <!-- ========== Go to Top ========== -->
    <a
      class="js-go-to go-to position-fixed invisible"
      href="#stickyBlockStartPoint"
      data-hs-go-to-options="{
          &quot;targetSelector&quot; : &quot;#logoAndNav&quot;,
          &quot;offsetTop&quot;: 200,
          &quot;position&quot;: {
            &quot;init&quot;: {
              &quot;right&quot;: 30
            },
            &quot;show&quot;: {
              &quot;bottom&quot;: 30
            },
            &quot;hide&quot;: {
              &quot;bottom&quot;: -30
            }
          }
        }"
    >
      <i class="fas fa-angle-up" />
    </a>
    <!-- ========== End Go to Top ========== -->
  </div>
</template>

<script>
const $ = require('jquery')
import ApiCarousel from '@/components/api-carousel'
import HowItWorkCarousel from '@/components/howitwork-carousel'
import HSGoTo from '@/assets/vendor/hs-go-to/src/js/hs-go-to'
import providerInfoMixin from '@/mixins/provider-info'
import QuickLinks from './data/quick-links.json'
import { mapGetters } from 'vuex'

export default {
  name: 'ProviderInfoBrandedHomeModern',
  components: {
    ApiCarousel,
    HowItWorkCarousel
  },
  mixins: [providerInfoMixin],
  props: {
    latestApis: {
      type: Array,
      default: () => []
    },
    themeColor: {
      type: String,
      default: '#57ABF0'
    }
  },
  data() {
    return {
      home_cards: QuickLinks,
      loaded: false
    }
  },
  computed: {
    ...mapGetters(['userProfile', 'loading'])
  },
  watch: {
    async userProfile() {
      await this.initialise()
    },
    latestApis: {
      deep: true,
      handler() {}
    }
  },
  beforeDestroy() {
    window.document.styleSheets[0].deleteRule(window.document.styleSheets[0].cssRules.length - 1)
  },
  async created() {
    await this.initialise()
  },
  mounted() {
    new HSGoTo($('.js-go-to')).init()
    var sheet = window.document.styleSheets[0]
    sheet.insertRule(
      `#modern-hero-section, #modern-cta-section {
        background-image: url(${require('@/assets/svg/cover.svg')});
      }`,
      sheet.cssRules.length
    )
  },
  methods: {
    async initialise() {
      this.$store.dispatch('app/setLoading', true)
      this.loaded = false
      var routeParams = this.$route.params && this.$route.params.provider_name.split('-')
      this.provider_short_id = routeParams[routeParams.length - 1]
      this.loaded = true
      this.$store.dispatch('app/setLoading', false)
    },
    goToApiInfo(item) {
      try {
        this.$router.push({
          name: 'api-info-branded',
          params: {
            provider_name: (item.display_name.toLowerCase().replace(/[^A-Za-z0-9]/g, '-').concat(`-${item.provider_short_id}`)).replace(/\-+/g, '-'),
            api_name: (item.api_name.toLowerCase().replace(/[^A-Za-z0-9]/g, '-').concat(`-${item.api_short_id}`)).replace(/\-+/g, '-'),
            tab_name: 'readme'
          }
        })
      } catch (err) {
        console.log('err in goToApiInfo', err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~slick-carousel/slick/slick.css';
@import '~slick-carousel/slick/slick-theme.css';
.transparent-button{
    background-color: transparent !important;
    border-color: white !important;
}
.quick_link-mt{
    margin-top:-100px;
}
.quick_link-pb{
    padding-bottom:4rem;
}
.fs-48{
    font-size:48px
}
.cover-bg{
    background-size: cover;
}
.whitespace {
  white-space: pre-wrap;
}
.bg-img {
    padding-bottom:164px;
  border-bottom-left-radius: 200% 133px;
  border-bottom-right-radius: 200% 133px;
}
.api-carousel-featured .slick-track {
  margin-left: 0;
}
.hero-section-conatiner {
    display: flex;
  .hero-section {
    width: 80%;
    max-width: 1200px;
    padding-top: 64px;
    margin: auto;
    text-align: center;
    .title {
      font-size: 48px;
    }
    .description {
      font-size: 20px;
      margin-bottom: 0px;
    }
  }
}

.project-highlights-section {
    text-align: center;
    .title {
        font-size: 30px;
        margin-bottom: 32px;
    }
    .statistic {
        flex: 1 1 100%;
        .number {
            font-size: 40px;
            font-weight: 600;
            margin-bottom: 8px;
        }
        .subtitle {
            font-size: 20px;
        }
    }
    .hr {
        border-right: 0.5px solid #E5E5E5;
    }
}

.feature-card {
  padding: 0px;
  .card-body {
    .icon-container {
      margin: 0px 24px 0px 0px;
        width: 70px;
        height: 70px;
        min-width: 70px;
        min-height: 70px;
        border-radius: 50%;
        background-color: rgba(33,52,95,0.1);
        .icon {
        width: inherit;
        height: inherit;
        font-size: 25px;
        display: flex;
        justify-content: center;
        }
    }
    .title {
        font-size: 20px;
        margin: 16px 0px;
    }
    .description {
        font-size: 16px;
    }
    .button-container {
        margin-top: 16px;
        display: flex;
        justify-content: flex-start;
    }
  }
}

.section-title {
    font-size: 30px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 41px;
}

// .feature-card-container .feature-card:nth-child(odd){
//   .card-body{
//     margin-right: 15px;
//     margin-bottom: 30px;
//   }
// }

// .feature-card-container .feature-card:nth-child(even){
//     .card-body{
//         margin-left: 15px;
//         margin-bottom: 30px;
//     }
// }
.call-to-action-section {
    // padding: 48px;
    // border-radius: 5px;
    // background-color: #FAFAFA;
    // box-shadow: 0 4px 12px 0 rgba(0,0,0,0.08);
    .title {
        font-size: 30px;
        margin-bottom: 16px;
    }
}
.call-to-action-section {
    // padding: 48px;
    // border-radius: 5px;
    // background-color: #FAFAFA;
    // box-shadow: 0 4px 12px 0 rgba(0,0,0,0.08);
    .title {
        font-size: 30px;
        margin-bottom: 16px;
    }
    .description {
        font-size: 16px;
    }
}

.button-container {
    margin-top: 16px;
    display: flex;
    // flex-direction: row;
    justify-content: center;
}

// .section-container .section:last-child {
//     padding-bottom: 8rem !important;
// }
@media screen and (max-width: 991px) {
    .quick_link-pb{
    padding-bottom:2rem;
    }
}
@media screen and (max-width: 992px) {

    .hr {
        border-right-width: 0px !important;
    }
    .feature-card-container .feature-card:nth-child(odd){
        .card-body{
            margin-right: 0px;
        }
    }

    .feature-card-container .feature-card:nth-child(even){
        .card-body{
            margin-left: 0px;
        }
    }

    .section-container .section:last-child {
        padding-bottom: 4rem !important;
    }
}

.section:nth-child(2n+4){
    background-color:#FAFAFA;
}
.invisible {
  visibility: hidden;
}
</style>
